export default [
  '#ff9b87',
  '#82c36a',
  '#009be9',
  '#E6A23C',
  '#909399',
  '#ea7ccc',
  '#9a60b4',
  '#fc8452',
  '#e6a0c4',
  '#c6cdf7',
  '#d8a499',
  '#7294d4',
  '#5ec9db',
  '#fdc765',
  '#f27d51',
  '#6462cc',
  '#ff5384',
  '#4456c7',
  '#ff80a0',
  '#ffc900',
  '#595959',
  '#ff5338',
  '#8190ff'
]
